export default __webpack_public_path__ + "static/FortArena-24d398e0c2d554693d79c41683a1da70.png";